
// Link „(N opinii)” z kafelka: na karcie produktu przewijamy do opinii. Adres z #judgeme_product_reviews
// traci znacznik przy ładowaniu strony, więc kliknięcie zapisuje też flagę w sessionStorage.
// Widżet Judge.me pojawia się po załadowaniu strony, dlatego czekamy na niego (03.10, Łukasz)
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.wt-rating__link');
    if (a) { try { sessionStorage.setItem('pcOpinie', '1'); } catch (err) {} }
  });
  var flaga = false;
  try { flaga = sessionStorage.getItem('pcOpinie') === '1'; sessionStorage.removeItem('pcOpinie'); } catch (err) {}
  if (!flaga && location.hash !== '#judgeme_product_reviews') return;
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  // przewijamy dopiero po pełnym załadowaniu strony i widżetu; strona po załadowaniu potrafi wrócić na górę,
  // więc jeszcze raz sprawdzamy po chwili
  var proby = 0;
  var t = setInterval(function () {
    var el = document.getElementById('judgeme_product_reviews');
    var gotowe = document.readyState === 'complete' && el && el.offsetHeight > 300;
    if (gotowe || ++proby > 60) {
      clearInterval(t);
      if (!el) return;
      var jedz = function () {
        // poprawka o wysokość przypiętego nagłówka, żeby nie zasłaniał tytułu opinii
        var naglowek = document.querySelector('.page-header, .wt-header');
        var h = naglowek ? naglowek.getBoundingClientRect().height : 0;
        window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - h - 16, behavior: 'auto' });
      };
      jedz();
      setTimeout(function () { if (Math.abs(el.getBoundingClientRect().top) > 300) jedz(); }, 900);
    }
  }, 250);
})();
